import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/motion/Reveal";

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    api
      .get("/courses")
      .then((r) => { if (!cancel) setCourses(r.data); })
      .catch(() => { if (!cancel) setCourses([]); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, []);

  return (
    <div data-testid="courses-page" className="bg-navy">
      <PageHero
        testid="courses-hero"
        overline="The Curriculum"
        lines={[
          <>Ten programmes for</>,
          <>
            the <em className="italic text-[#C6A87C]">full IP value chain.</em>
          </>,
        ]}
        sub="From a first-principles understanding of patent claims to executive-grade IP strategy — every track is taught by Venkataramanan and reviewed 1:1 by a mentor."
      />
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 xl:px-24 pb-24 lg:pb-32">
        <div className="border-b border-[#C6A87C]/10">
          {loading && (
            <div data-testid="courses-loading" className="py-12 text-[#8A99AA] font-light">
              Loading programmes...
            </div>
          )}
          {courses.map((c, i) => (
            <Reveal key={c.slug} delay={Math.min(i * 0.05, 0.35)} y={20}>
              <Link
                to={`/courses/${c.slug}`}
                data-testid={`course-row-${c.slug}`}
                className="group block border-t border-[#C6A87C]/10 py-10 px-2 transition-[background-color,padding] duration-500 hover:bg-[#C6A87C]/[0.04] hover:pl-6"
              >
                <div className="grid lg:grid-cols-12 gap-6 items-start">
                  <div className="lg:col-span-1 font-mono-tech text-xs text-[#C6A87C]/70 tracking-widest pt-2">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="lg:col-span-6">
                    <h2 className="font-serif text-3xl lg:text-4xl text-[#F5F4F0] group-hover:text-[#C6A87C] transition-colors duration-300 leading-tight">
                      {c.title}
                    </h2>
                    <p className="mt-2 text-[#8A99AA] text-lg font-light">{c.tagline}</p>
                  </div>
                  <div className="lg:col-span-3 text-sm text-[#8A99AA] space-y-1.5 font-light">
                    <div><span className="label-overline !text-[10px] mr-2">Duration</span> {c.duration}</div>
                    <div><span className="label-overline !text-[10px] mr-2">Level</span> {c.level}</div>
                    <div><span className="label-overline !text-[10px] mr-2">Format</span> {c.format}</div>
                  </div>
                  <div className="lg:col-span-2 lg:text-right flex lg:justify-end">
                    <span className="inline-flex items-center gap-2 text-[#C6A87C] text-xs uppercase tracking-[0.14em]">
                      Read more
                      <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
